<template>
    <v-app
        id="inspire"
        style="max-width: 100vw; overflow: hidden;"
    >
        <v-main>
            <video-background
                :sources="[]"
                :img="'/static/video/background.png'"
            >
<!--                :sources="['/static/video/'+ video +'.mp4']"-->
                <v-container fluid fill-height>
                    <v-layout
                        justify-center
                        align-center
                        column
                    >
                        <slot></slot>
                    </v-layout>
                </v-container>
            </video-background>
        </v-main>
    </v-app>
</template>
<script>

    export default {
        data() {
            return {
                videos: ['1', '2', '3'],
            }
        },
        name: 'Auth-Container',
        computed: {
            video() {
                return this.videos[Math.floor(Math.random() * this.videos.length)];
            }
        },
        mounted() {
            if (document.getElementById('preloader')) {
                this.$store.dispatch('auth/removePreloader');
            }
        },
    }
</script>

